import React from "react";
import styled from "styled-components";
import Topmenu from "../Buttered_Topmenu";
import BottomMenu from "../Buttered_BottomMenu";
import raw from "../../../language/Eng_Aust.json";
import { TransitionContainer } from "../animation/TransitionContainer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
const en = raw as any;

const RenderWithLineBreaks = ({ text }: { text?: string }) => {
  if (!text) return null;
  return (
    <>
      {text.split(/<br\s*\/?>|\n/g).map((line, index) => (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      ))}
    </>
  );
};

const Buttered_About = () => {
  return (
    <TransitionContainer>
      <Container>
        <Topmenu />
        <CenteredImageWrapper>
          <img
            src={
              process.env.PUBLIC_URL +
              "/assets/Buttered/Buttered_logo/MainLogo3.webp"
            }
            alt="Main Logo"
          />
        </CenteredImageWrapper>

        {/* Our Story Section */}
        <StorySection>
          <SectionTitle>{en.about?.story?.title}</SectionTitle>
          <StoryContent>
            <StoryText>
              <StoryParagraph>
                <strong>{en.about?.story?.paragraph1}</strong>
              </StoryParagraph>
              <StoryParagraph>
                <RenderWithLineBreaks text={en.about?.story?.paragraph2} />
              </StoryParagraph>
            </StoryText>
            <StoryImageCard>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/assets/Buttered/dessert_image/Breadcollection.webp"
                }
                alt="Our Story"
              />
            </StoryImageCard>
          </StoryContent>
        </StorySection>

        <StorySection>
          <StoryContent>
            <StoryText>
              <StoryParagraph>
                <RenderWithLineBreaks text={en.about?.story2?.paragraph2} />
              </StoryParagraph>
            </StoryText>
            <StoryImageCard>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/assets/Buttered/dessert_image/cakes.webp"
                }
                alt="Our Story"
              />
            </StoryImageCard>
          </StoryContent>
        </StorySection>

        {/* Featured Products Section */}
        <FeaturedSection>
          <SectionTitle>{en.about?.featured?.title}</SectionTitle>

          {/* ⭐️ FloatingImage와 FeaturedGrid를 감싸는 새로운 컨테이너 추가 ⭐️
            FeaturedGridContainer가 position: relative 기준점이 됩니다.
          */}
          <FeaturedGridContainer>
            <FloatingImage
              src={
                process.env.PUBLIC_URL +
                "/assets/Buttered/Buttered_logo/Top_Menu_logo.webp"
              }
              alt="버터 이미지"
            />
            <FeaturedGrid>
              <FeaturedCard>
                <FeaturedImageWrapper>
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/Buttered/dessert_image/SignatureBread.webp"
                    }
                    alt="Featured Product 1"
                  />
                </FeaturedImageWrapper>
                <FeaturedContent>
                  <FeaturedTitle>
                    {en.about?.featured?.item1?.title}
                  </FeaturedTitle>
                  <FeaturedDescription>
                    {en.about?.featured?.item1?.description}
                  </FeaturedDescription>
                </FeaturedContent>
              </FeaturedCard>

              <FeaturedCard>
                <FeaturedImageWrapper>
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/Buttered/dessert_image/MadeWithLoves.webp"
                    }
                    alt="Featured Product 2"
                  />
                </FeaturedImageWrapper>
                <FeaturedContent>
                  <FeaturedTitle>
                    {en.about?.featured?.item2?.title}
                  </FeaturedTitle>
                  <FeaturedDescription>
                    {en.about?.featured?.item2?.description}
                  </FeaturedDescription>
                </FeaturedContent>
              </FeaturedCard>

              <FeaturedCard>
                <FeaturedImageWrapper>
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/Buttered/dessert_image/CustomCakes.webp"
                    }
                    alt="Featured Product 3"
                  />
                </FeaturedImageWrapper>
                <FeaturedContent>
                  <FeaturedTitle>
                    {en.about?.featured?.item3?.title}
                  </FeaturedTitle>
                  <FeaturedDescription>
                    {en.about?.featured?.item3?.description}
                  </FeaturedDescription>
                </FeaturedContent>
              </FeaturedCard>
            </FeaturedGrid>
          </FeaturedGridContainer>
        </FeaturedSection>

        {/* Values Section */}
        <ValuesSection>
          <SectionTitle>{en.about?.values?.title}</SectionTitle>
          <ValuesGrid>
            <ValueCard>
              <ValueIconWrapper>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/Buttered/Buttered_logo/About_image_1.svg"
                  }
                  alt="Quality"
                />
              </ValueIconWrapper>
              <ValueContent>
                <ValueTitle>{en.about?.values?.quality?.title}</ValueTitle>
                <ValueDescription>
                  {en.about?.values?.quality?.description}
                </ValueDescription>
              </ValueContent>
            </ValueCard>

            <ValueCard>
              <ValueIconWrapper>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/Buttered/Buttered_logo/About_image_2.webp"
                  }
                  alt="Passion"
                />
              </ValueIconWrapper>
              <ValueContent>
                <ValueTitle>{en.about?.values?.passion?.title}</ValueTitle>
                <ValueDescription>
                  {en.about?.values?.passion?.description}
                </ValueDescription>
              </ValueContent>
            </ValueCard>

            <ValueCard>
              <ValueIconWrapper>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/Buttered/Buttered_logo/About_image_3.svg"
                  }
                  alt="Creativity"
                />
              </ValueIconWrapper>
              <ValueContent>
                <ValueTitle>{en.about?.values?.creativity?.title}</ValueTitle>
                <ValueDescription>
                  {en.about?.values?.creativity?.description}
                </ValueDescription>
              </ValueContent>
            </ValueCard>
          </ValuesGrid>
        </ValuesSection>
        <BottomMenu />
      </Container>
    </TransitionContainer>
  );
};

export default Buttered_About;

// Styled Components - Material 3 Expressive Style
const Container = styled.div`
  min-height: 100vh;
  background: #faf8f5;
`;

const CenteredImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 0 40px;

  img {
    max-width: 100%;
    height: auto;
    filter: drop-shadow(0 4px 20px rgba(0, 0, 0, 0.08));
  }
`;

const StorySection = styled.section`
  padding: 60px 5%;
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 3rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 60px;
  color: #342e28;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }
`;

const StoryContent = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 40px;
  align-items: center;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const StoryText = styled.div`
  padding: 20px;
`;

const StoryParagraph = styled.p`
  font-size: 1.15rem;
  line-height: 1.9;
  color: #4a4a4a;
  margin-bottom: 24px;
  font-weight: 400;
  letter-spacing: 0.01em;
`;

const StoryImageCard = styled.div`
  background: #fffdf9;
  border-radius: 32px;
  padding: 12px;
  border: 1px solid #eee7dd;
  box-shadow: 0 10px 32px rgba(56, 46, 35, 0.07);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-8px) scale(1.02);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
  }

  img {
    width: 100%;
    height: 280px;
    object-fit: cover;
    border-radius: 24px;
  }
`;

const FeaturedSection = styled.section`
  padding: 80px 5%;
  background: #fff4c7;
  position: relative;
  overflow: hidden;
  /* FeaturedSection에는 position: relative가 유지되어야 합니다. */
`;

// ⭐️ 새로 추가된 컨테이너: 버터 이미지의 위치 기준점을 중앙 콘텐츠 영역으로 만듭니다. ⭐️
const FeaturedGridContainer = styled.div`
  position: relative;
  max-width: 1200px; /* FeaturedGrid와 동일한 최대 너비 */
  margin: 0 auto; /* 중앙 정렬 */
`;

const FeaturedGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 32px;
  /* FeaturedGridContainer가 중앙 정렬을 담당하므로 여기서 max-width와 margin은 제거 */
  width: 100%;
`;

const FeaturedCard = styled.div`
  background: #fffdf9;
  border-radius: 32px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-12px) scale(1.02);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  }
`;

const FeaturedImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 0 0 28px 28px;

  img {
    width: 100%;
    height: 280px;
    object-fit: cover;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }

  ${FeaturedCard}:hover & img {
    transform: scale(1.1);
  }
`;

const FeaturedContent = styled.div`
  padding: 28px;
`;

const FeaturedTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #2d2d2d;
  letter-spacing: -0.01em;
`;

const FeaturedDescription = styled.p`
  font-size: 1.05rem;
  color: #5a5a5a;
  line-height: 1.7;
  font-weight: 400;
`;

const ValuesSection = styled.section`
  padding: 80px 5%;
  max-width: 1200px;
  margin: 0 auto;
`;

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 32px;
`;

const ValueCard = styled.div`
  background: #fffdf9;
  border-radius: 32px;
  padding: 40px 32px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.12);
    background: #fff9df;
  }
`;

const ValueIconWrapper = styled.div`
  width: 240px;
  height: 240px;
  background: #fff1a6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  padding: 20px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  ${ValueCard}:hover & {
    transform: scale(1.05) rotate(5deg);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const ValueContent = styled.div``;

const ValueTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 16px;
  color: #2d2d2d;
  letter-spacing: -0.01em;
`;

const ValueDescription = styled.p`
  font-size: 1.05rem;
  color: #5a5a5a;
  line-height: 1.7;
  font-weight: 400;
`;

// ⭐️ FloatingImage CSS 수정: left 값을 음수로 조정하여 FeaturedGridContainer 밖으로 배치합니다. ⭐️
const FloatingImage = styled.img`
  position: absolute;
  top: -55px;
  left: -100px; /* <--- 이 값을 -30px에서 -200px 등으로 조정하여 중앙 콘텐츠 기준으로 왼쪽으로 이동 */
  width: 320px;
  transform: rotate(-24deg);
  z-index: 10;
  filter: drop-shadow(0 12px 32px rgba(0, 0, 0, 0.15));
  animation: float 6s ease-in-out infinite;

  @keyframes float {
    0%,
    100% {
      transform: rotate(-24deg) translateY(0px);
    }
    50% {
      transform: rotate(-24deg) translateY(-20px);
    }
  }

  @media (max-width: 1024px) {
    display: none;
  }
`;
